import { FC, ReactNode, useState } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Box, useTheme } from '@mui/material';

interface ScrollbarProps {
  className?: string;
  children?: ReactNode;
}

const Scrollbar: FC<ScrollbarProps> = ({ className, children, ...rest }) => {
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);
  
  // Get scrollbar color from theme if available, otherwise use default
  const sidebarConfig = (theme as any).sidebar;
  const scrollbarColor = sidebarConfig?.scrollbarColor || '#459AD4';
  const scrollbarHoverColor = sidebarConfig?.scrollbarColor || '#459AD4';

  return (
    <Scrollbars
      autoHide={!isHovered}
      autoHideTimeout={500}
      autoHideDuration={200}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      renderThumbVertical={(props) => (
        <Box
          {...props}
          sx={{
            width: 5,
            backgroundColor: scrollbarColor + ' !important',
            borderRadius: `${theme.general.borderRadiusLg}`,
            transition: `${theme.transitions.create(['background', 'opacity'])}`,
            opacity: isHovered ? 1 : 0.6,
            '&:hover': {
              backgroundColor: scrollbarHoverColor + ' !important',
              opacity: 1
            }
          }}
        />
      )}
      {...rest}
    >
      {children}
    </Scrollbars>
  );
};

Scrollbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Scrollbar;